
import { Vue, Prop, Component } from 'vue-property-decorator';
@Component({})
export default class DeviceDetailHook extends Vue {
  @Prop() detail!: any;
  @Prop() isEdit!: boolean;
}
